/**
 * Cookie Notice user choice
 * @author Frédéric Pineau
 * modifié par artwaï pour artwaï
 */
;
(function () {

    const labels = {
        'stats_nochoice': 'Vous n\'avez pas encore fait de choix concernant les cookies statistiques. ',
        'stats_validate': 'Vous avez explicitement accepté les cookies statistiques sur ce site. ',
        'stats_invalidate': 'Vous avez refusé l\'usage des cookies pour les statistiques et de mesures d\'audience du site. ',
        
        'video_nochoice': 'Vous n\'avez pas encore fait de choix concernant les cookies videos. Ce choix vous sera proposé au moment opportun. ',
        'video_validate': 'Vous avez explicitement accepté les cookies provenant de(s) service(s) vidéo(s) suivant(s)&nbsp;: <br class="hide-xs" />'
    };

    function readCookie(cookieName) {

        const re = new RegExp('[; ]' + cookieName + '=([^\\s;]*)');
        const sMatch = (' ' + document.cookie).match(re);
        if (cookieName && sMatch) return unescape(sMatch[1]);
        return 'invalidate';
    }
    
    
    function deleteCookie(cookieName) {

        document.cookie = cookieName + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;' ;
        console.log("COOKIE : Vous avez supprimé le cookie " + cookieName );
    }
    
    function createDismissButton(message, buttonClass) {

        const dismissButton = document.createElement('a');

        // Dismiss button
        dismissButton.href = '#';
        dismissButton.innerHTML = message;
        dismissButton.style.padding = '4px 1em';
        dismissButton.style.height = 'auto';
        dismissButton.style.verticalAlign = 'middle';
        dismissButton.className = buttonClass;

        return dismissButton;
    }

    //-------------------------------------------------- cookie_notice

    const cookieNoticeValue = readCookie('cookie_notice');

    const containerNotice = document.getElementById("cookie_notice_user_choice");
    if(containerNotice) {
        containerNotice.className = 'bg-2 text-center';
        containerNotice.style.padding = '1em';
    }

    const dismissButton = createDismissButton('Changer d\'avis', 'bg-9 btn');
    if(dismissButton) {
        dismissButton.addEventListener('click', e => {
            e.preventDefault();
            deleteCookie('cookie_notice');
            document.location.reload();
        });
    }

    const br = document.createElement('br');
    br.className = 'visible-xs';


    if (cookieNoticeValue === "0") {
        containerNotice.innerHTML = labels.stats_invalidate;
        containerNotice.appendChild(br);
        containerNotice.appendChild(dismissButton);
    }
    else if (cookieNoticeValue === "1") {
        containerNotice.innerHTML = labels.stats_validate;
        containerNotice.appendChild(br);
        containerNotice.appendChild(dismissButton);
    }
    else {
        containerNotice.innerHTML = labels.stats_nochoice;
    }
    
    //-------------------------------------------------- cookie_video
    
    const cookieVideoValue = readCookie('cookie_video');

    const container = document.getElementById("cookie_video_user_choice");
    if(container) {
        container.className = 'bg-2 text-center';
        container.style.padding = '1em';

        const dismissButton = createDismissButton('Supprimer', 'bg-9 btn');

        dismissButton.addEventListener('click', e => {
            e.preventDefault();
            deleteCookie('cookie_video');
            document.location.reload();
        });

        const br = document.createElement('br');
        br.className = 'visible-xs';


        if (cookieVideoValue != 'invalidate') {
            container.innerHTML = labels.video_validate + cookieVideoValue.replace('|', ', ') +'. ';
            container.appendChild(br);
            container.appendChild(dismissButton);
        }
        
        else {
            container.innerHTML = labels.video_nochoice;
        }
    }

    
}());